export const ipccBiogenicsMethodNames = ['IPCC 2021 (incl. biogenic CO2)', 'IPCC 2021 (incl. biogenic CO2) no LT'];
